export const GetArmedServiceSelector = ({
  armedservice: { GetArmedService }
}) => GetArmedService;
export const ArmedServiceSelector = ({ armedservice: { ArmedService } }) =>
  ArmedService;
